// extracted by mini-css-extract-plugin
export var container = "_e7-0";
export var icon = "_e7-1";
export var text = "_e7-2";